import { h } from 'preact';
import { useStore } from 'src/hooks';
import { PROMO } from 'src/common/constants';
import * as styles from 'src/components/sidebar/promo/styles.less';

interface PromoLogoProps {
    isFrame?: boolean;
}

const PromoLogo = ({ isFrame }: PromoLogoProps) => {
    const ctx = useStore();
    const promoType = ctx.promo.type.value;
    const isLoggedIn = ctx.user.isLoggedIn.value;

    if (promoType) {
        if (isLoggedIn) {
            return (
                <a class={`${styles.promo_logo} ${styles[PROMO[promoType].layoutClass]}`} rel="home" href={PROMO[promoType].route} title={PROMO[promoType].title} data-native={isFrame ? true : null} target={isFrame ? '_top' : undefined}>
                    <b>CamContacts</b>
                    <div class={styles.promo_logo__inner} />
                </a>
            );
        }

        return (
            <div class={`${styles.promo_logo} ${styles[PROMO[promoType].layoutClass]}`}>
                <b>CamContacts</b>
                <div class={styles.promo_logo__inner} />
            </div>
        );
    }

    return null;
};

export default PromoLogo;
